import { environment } from '@/sub-luca-plugin/utils';
import { cashier_address } from '@/sub-luca-plugin/apis';
import { defaultOrderPay, handleCreactOrder } from './create';
import { IEquityInitInfo } from '@/sub-luca-plugin/types';

export const handleOrderPay = async (productId: number, ininInfo?: IEquityInitInfo): Promise<string> =>
    new Promise(async (reolve, reject) => {
        const returnUrl = `https://${environment.getEnv()}muses.gaodun.com/ape/luca/pay/result?pid=${ininInfo?.projectId}`;
        const orderPay: any = {
            ...defaultOrderPay,
            payBackUrl: returnUrl,
        };
        // 创建用户订单
        const orderInfo = await handleCreactOrder(productId, orderPay);
        if (orderInfo.orderPrice === 0) {
            reolve('购买成功');
            return;
        }
        // 获取收银台地址
        const payRes = await cashier_address({
            orderNo: orderInfo.orderNo,
            returnUrl: returnUrl,
        });
        if (payRes.status === 0) {
            window.open(payRes.result.payUrl);
        } else {
            reject('支付失败');
        }
    });
